// @flow
import React, { type Element } from 'react';
import ReactDom from 'react-dom';
import { isUndefined, isEqual, get } from 'lodash';
import { Row, EllipsedPagination } from 'angieslist-react-components';
import {
  getPageCount,
  getOffset,
  getPageNum,
} from 'angieslist-app-platform/lib/common/utils/paginationUtils';
import ReviewCard from './ReviewCard';
import reviewsActions, { API_LIMIT } from '../../../common/reviewsActions';
import type { BrowserReducerState, Reviews } from '../../../types';

type Props = {
  finishedLoading: boolean,
  reviewId?: string,
  reviews: Reviews[],
  reviewCount?: number,
  serviceProviderId: string,
  categoryId: number,
  offset?: number,
  browser: BrowserReducerState,
  sortType: string,
  sortDirection: string,
  starRatingFilters: number[],
  getReviews: typeof reviewsActions.getReviews,
};

class ReviewCardsComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.reviewCardRefs = {};
  }
  componentDidMount() {
    const {
      reviewId,
      finishedLoading,
    } = this.props;
    if (reviewId) {
      const reviewCardRef = get(this, `reviewCardRefs.${reviewId}`);
      if (reviewCardRef && finishedLoading) {
        // eslint-disable-next-line react/no-find-dom-node
        const reviewCardRefElement = (ReactDom.findDOMNode(reviewCardRef): any);
        setTimeout(() => reviewCardRefElement
          && reviewCardRefElement.scrollIntoView
          && reviewCardRefElement.scrollIntoView(true), 10);
      }
    }
  }
  componentDidUpdate() {
    const {
      reviewId,
      finishedLoading,
    } = this.props;
    if (reviewId) {
      const reviewCardRef = get(this, `reviewCardRefs.${reviewId}`);
      if (reviewCardRef && finishedLoading) {
        // eslint-disable-next-line react/no-find-dom-node
        const reviewCardRefElement = (ReactDom.findDOMNode(reviewCardRef): any);
        setTimeout(() => reviewCardRefElement
          && reviewCardRefElement.scrollIntoView
          && reviewCardRefElement.scrollIntoView(true), 10);
      }
    }
  }
  props: Props;
  reviewCardRefs: { [key: string]: ReviewCard };
  render(): Element<"div"> {
    const {
      reviews, reviewCount, offset,
      getReviews, serviceProviderId, categoryId,
      browser, sortType, sortDirection, starRatingFilters,
    } = this.props;
    const reviewsPerPage = API_LIMIT;
    const pageCount = getPageCount(reviewCount, reviewsPerPage);
    const pageIndex = getPageNum(offset, reviewsPerPage) - 1;
    const results = (isUndefined(reviews) ? [] : reviews)
      .map(review => review.reviewId);
    return (
      <div>
        <If condition={reviews}>
          {
            reviews.map((review, index) => {
              const rank = index + 1;
              return (
                <ReviewCard
                  ref={(r) => {
                    const newRefs = { ...this.reviewCardRefs, [`${review.reviewId}`]: r };
                    this.reviewCardRefs = newRefs;
                  }}
                  key={review.reviewId}
                  {...{
                    rank,
                    review,
                    results,
                    browser,
                    serviceProviderId,
                  }}
                />
              );
            })
          }
        </If>
        <Row>
          <EllipsedPagination
            pageCount={pageCount}
            pageIndex={pageIndex}
            onChange={(index) => {
              (getReviews(
                serviceProviderId,
                categoryId,
                starRatingFilters,
                sortDirection,
                sortType,
                getOffset(index + 1, reviewsPerPage),
              ): any).then(() => {
                  if (isEqual(process.env.IS_BROWSER, true)) {
                    window.scrollTo(0, 120);
                  }
                });
            }}
          />
        </Row>
      </div>
    );
  }
}
export default ReviewCardsComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewCards.js